import { memo, useEffect, useState } from "react";

import { LoadingShim } from "@narmi/design_system";
import { modules } from "byzantine";
import {
  WireTypeEnum,
  wireTypeSelectorForm,
  type WireType,
} from "byzantine/src/dbbl/businessLogic/modules/internationalWires/WireTransferContainer.form";

import Container from "../../../../components/Container";
import {
  WireTransferRedesign,
  WireTransferContainer,
} from "../../../../components/transfer/wires";

import WireTemplatesScreen from "./templates/templates.screen";

type Props = {
  limits: API.Limits.ByType;
};

function BootstrappedWireTransfer({
  limits,
  setWireType,
}: Props & { setWireType: (wireType: WireType) => void }) {
  const { loading, load } = modules.wireTemplates.bootstrap.useBootstrap();

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <LoadingShim isLoading>
        <div style={{ height: "100vh" }} />
      </LoadingShim>
    );
  }

  return (
    <Container>
      <WireTransferRedesign limits={limits} setWireType={setWireType} />
    </Container>
  );
}

function WireTransfer({ limits }: Props) {
  const { fedwireTemplatesEnabled, internationalWires } =
    modules.wireTemplates.useWirePermissions();
  const { values: wireTypeSelectorValues } = wireTypeSelectorForm.useForm();
  const [wireType, setWireType] = useState<WireType>(
    wireTypeSelectorValues.wireType || WireTypeEnum.None
  );

  if (internationalWires && wireType !== "domestic") {
    return <WireTransferContainer setWireType={setWireType} />;
  }

  if (fedwireTemplatesEnabled) {
    if (wireType === WireTypeEnum.None) {
      setWireType(WireTypeEnum.Domestic);
    }
    return (
      <Container>
        <WireTemplatesScreen setWireType={setWireType} wireType={wireType} />
      </Container>
    );
  }

  return <BootstrappedWireTransfer limits={limits} setWireType={setWireType} />;
}

export default memo(WireTransfer);
